// @flow
import React from "react";
import Chip from "@material-ui/core/Chip";
import {
  PrimaryGreen,
  ThirdGreen,
  GreyText,
  WhiteText,
  BlueText,
  BlackText,
  SecondaryGreen
} from "../../../global/uis/scss";

type LicenceTypeLabelPropsType = {
  licenceType: string,
  className?: string
};

const LicenceTypeLabel = (
  props: LicenceTypeLabelPropsType
): React$Element<*> => {
  const licenceType = props.licenceType;
  let label = "";
  let style = {};
  if (licenceType === "LONGTERM") {
    label = "Long Term Licence";
    style = { backgroundColor: PrimaryGreen, color: WhiteText };
  } else if (licenceType === "SHORTTERM") {
    label = "Short Term Licence";
    style = { backgroundColor: ThirdGreen, color: WhiteText };
  } else if (licenceType === "DEMO") {
    label = "Demo Licence";
    style = { backgroundColor: GreyText, color: BlackText };
  } else if (licenceType === "EVALUATION") {
    label = "Evaluation Licence";
    style = { backgroundColor: BlueText, color: WhiteText };
  } else if (licenceType === "ONEYEAR") {
    (label = "One Year Licence"),
      (style = { backgroundColor: SecondaryGreen, color: WhiteText });
  }

  if (label === "") {
    return <span className={props.className}></span>;
  } else {
    return <Chip label={label} className={props.className} style={style} />;
  }
};

export default LicenceTypeLabel;
